import axios from 'axios';

export const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_UI_BASE_PATH}/`,
  withCredentials: true,
  headers: {
    'Access-Control-Allow-Headers': 'Accept',
  },
});
